import React, { useState, useEffect } from "react";
import { GenericDialog } from "../../../generic/GenericDialog";
import { SignUpForm } from "./SignUpForm";
import { TermsAndConditions } from "./TermsAndConditions";
import { Verification } from "./Verification";
import { useFormik } from "formik";
import { object } from "yup";
import { SIGN_IN_FORMS } from "../../../../enums/signInFormEnums";
import { EmailVerified } from "./EmailVerified";
import { signUpValidations } from "../../../../helpers/genericFormValidations";
import { AccountExists } from "../login/AccountExists";
import { signUp } from "../../../../config/apisauce";

const minAge = 18;
const eighteenYearsAgo = new Date();
eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - minAge);

export const SignUpDialog = (props) => {
  const sessionReferrer = sessionStorage.getItem('sessionReferrer');
  const {
    selectedForm,
    setSelectedForm,
    handleCloseDialog,
    openSignInAndUpDialog,
    handleOpenLoginDialog
  } = props;

  const [isLoading, setIsloading] = useState(false);
  const [userData, setUserData] = useState({});
  const [unverifiedEmail, setUnverifiedEmail] = useState('');

  const handleNextForm = (data) => {
    setSelectedForm(data);
  };

  const handleClear = () => {
    handleCloseDialog();
    setUserData({});
    formik?.handleReset();
  };

  // const handleSubmit = async (data) => {
  //   const response = await validateFields(data);
  //   if (response.ok) {
  //     setUserData(data);
  //     handleNextForm(SIGN_IN_FORMS[1]);
  //   }
  // };

  const handleSubmit = async (values) => {
    setIsloading(true);
    const params = {
      ...values,
      ...(sessionReferrer && { meta: { reffered_by: sessionReferrer } })
    };
    const response = await signUp(params);
    if (response.ok) {
      setUserData(response?.data);
      handleNextForm(SIGN_IN_FORMS[2]);
    } else if (response?.data?.errors?.email_unverified) {
      setUnverifiedEmail(params?.email);
      handleNextForm(SIGN_IN_FORMS[4]);
    } else {
      handleNextForm(SIGN_IN_FORMS[0]);
    }
    setIsloading(false);
  };

  const formik = useFormik({
    initialValues: userData,
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: object().shape({ ...signUpValidations, }),
    enableReinitialize: true,
    onSubmit: (values) => handleSubmit(values),
  });

  const forms = {
    'sign-up': <SignUpForm formik={formik} isLoading={isLoading} handleOpenLoginDialog={handleOpenLoginDialog} />,
    'terms-conditions': <TermsAndConditions params={userData} handleNextForm={handleNextForm} />,
    'verify-email': <Verification email={userData?.email ?? selectedForm?.data?.email} />,
    'email-verified': <EmailVerified handleOpenLoginDialog={handleOpenLoginDialog} />,
    'account-exists': <AccountExists handleCancel={handleClear} email={unverifiedEmail} handleNextForm={handleNextForm} />
  };

  return (
    <GenericDialog
      openDialog={openSignInAndUpDialog}
      handleClose={() => handleClear()}
      title={selectedForm?.title}
      showClose={selectedForm?.showClose}
      width={selectedForm?.width}
    >
      {forms?.[selectedForm?.key]}
    </GenericDialog>
  );
};